/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as QrCodeScanImport } from './routes/qr-code-scan';
import { Route as PorterLoginImport } from './routes/porter-login';
import { Route as LoginImport } from './routes/login';
import { Route as HealthCenterLinkImport } from './routes/health-center-link';
import { Route as AppSelectImport } from './routes/app-select';
import { Route as AuthImport } from './routes/_auth';
import { Route as IndexImport } from './routes/index';
import { Route as AuthEnvironmentalCleaningRouteImport } from './routes/_auth/environmental-cleaning.route';
import { Route as AuthPatientTransportIndexImport } from './routes/_auth/patient-transport/index';
import { Route as AuthEnvironmentalCleaningIndexImport } from './routes/_auth/environmental-cleaning.index';
import { Route as AuthBedManagementIndexImport } from './routes/_auth/bed-management/index';
import { Route as AuthEnvironmentalCleaningMissionsImport } from './routes/_auth/environmental-cleaning.missions';
import { Route as AuthEnvironmentalCleaningDoneImport } from './routes/_auth/environmental-cleaning.done';
import { Route as AuthBedManagementStatisticsImport } from './routes/_auth/bed-management/statistics';
import { Route as AuthBedManagementRequestsImport } from './routes/_auth/bed-management/requests';
import { Route as AuthBedManagementArchivesImport } from './routes/_auth/bed-management/archives';
import { Route as AuthPatientTransportFaresRouteImport } from './routes/_auth/patient-transport/fares.route';
import { Route as AuthPatientTransportFaresIndexImport } from './routes/_auth/patient-transport/fares.index';
import { Route as AuthPatientTransportFaresDoneImport } from './routes/_auth/patient-transport/fares.done';
import { Route as AuthPatientTransportFaresActiveImport } from './routes/_auth/patient-transport/fares.active';
import { Route as AuthEnvironmentalCleaningMissionsIdImport } from './routes/_auth/environmental-cleaning.missions.$id';
import { Route as AuthBedManagementRequestsIdImport } from './routes/_auth/bed-management/requests.$id';
import { Route as AuthBedManagementArchivesIdImport } from './routes/_auth/bed-management/archives.$id';
import { Route as AuthPatientTransportFaresActiveIdReportIncidentImport } from './routes/_auth/patient-transport/fares.active.$id.report-incident';

// Create/Update Routes

const QrCodeScanRoute = QrCodeScanImport.update({
  id: '/qr-code-scan',
  path: '/qr-code-scan',
  getParentRoute: () => rootRoute,
} as any);

const PorterLoginRoute = PorterLoginImport.update({
  id: '/porter-login',
  path: '/porter-login',
  getParentRoute: () => rootRoute,
} as any);

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any);

const HealthCenterLinkRoute = HealthCenterLinkImport.update({
  id: '/health-center-link',
  path: '/health-center-link',
  getParentRoute: () => rootRoute,
} as any);

const AppSelectRoute = AppSelectImport.update({
  id: '/app-select',
  path: '/app-select',
  getParentRoute: () => rootRoute,
} as any);

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const AuthEnvironmentalCleaningRouteRoute = AuthEnvironmentalCleaningRouteImport.update({
  id: '/environmental-cleaning',
  path: '/environmental-cleaning',
  getParentRoute: () => AuthRoute,
} as any);

const AuthPatientTransportIndexRoute = AuthPatientTransportIndexImport.update({
  id: '/patient-transport/',
  path: '/patient-transport/',
  getParentRoute: () => AuthRoute,
} as any);

const AuthEnvironmentalCleaningIndexRoute = AuthEnvironmentalCleaningIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthEnvironmentalCleaningRouteRoute,
} as any);

const AuthBedManagementIndexRoute = AuthBedManagementIndexImport.update({
  id: '/bed-management/',
  path: '/bed-management/',
  getParentRoute: () => AuthRoute,
} as any);

const AuthEnvironmentalCleaningMissionsRoute = AuthEnvironmentalCleaningMissionsImport.update({
  id: '/missions',
  path: '/missions',
  getParentRoute: () => AuthEnvironmentalCleaningRouteRoute,
} as any);

const AuthEnvironmentalCleaningDoneRoute = AuthEnvironmentalCleaningDoneImport.update({
  id: '/done',
  path: '/done',
  getParentRoute: () => AuthEnvironmentalCleaningRouteRoute,
} as any);

const AuthBedManagementStatisticsRoute = AuthBedManagementStatisticsImport.update({
  id: '/bed-management/statistics',
  path: '/bed-management/statistics',
  getParentRoute: () => AuthRoute,
} as any);

const AuthBedManagementRequestsRoute = AuthBedManagementRequestsImport.update({
  id: '/bed-management/requests',
  path: '/bed-management/requests',
  getParentRoute: () => AuthRoute,
} as any);

const AuthBedManagementArchivesRoute = AuthBedManagementArchivesImport.update({
  id: '/bed-management/archives',
  path: '/bed-management/archives',
  getParentRoute: () => AuthRoute,
} as any);

const AuthPatientTransportFaresRouteRoute = AuthPatientTransportFaresRouteImport.update({
  id: '/patient-transport/fares',
  path: '/patient-transport/fares',
  getParentRoute: () => AuthRoute,
} as any);

const AuthPatientTransportFaresIndexRoute = AuthPatientTransportFaresIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthPatientTransportFaresRouteRoute,
} as any);

const AuthPatientTransportFaresDoneRoute = AuthPatientTransportFaresDoneImport.update({
  id: '/done',
  path: '/done',
  getParentRoute: () => AuthPatientTransportFaresRouteRoute,
} as any);

const AuthPatientTransportFaresActiveRoute = AuthPatientTransportFaresActiveImport.update({
  id: '/active',
  path: '/active',
  getParentRoute: () => AuthPatientTransportFaresRouteRoute,
} as any);

const AuthEnvironmentalCleaningMissionsIdRoute = AuthEnvironmentalCleaningMissionsIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthEnvironmentalCleaningMissionsRoute,
} as any);

const AuthBedManagementRequestsIdRoute = AuthBedManagementRequestsIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthBedManagementRequestsRoute,
} as any);

const AuthBedManagementArchivesIdRoute = AuthBedManagementArchivesIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthBedManagementArchivesRoute,
} as any);

const AuthPatientTransportFaresActiveIdReportIncidentRoute =
  AuthPatientTransportFaresActiveIdReportIncidentImport.update({
    id: '/$id/report-incident',
    path: '/$id/report-incident',
    getParentRoute: () => AuthPatientTransportFaresActiveRoute,
  } as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/_auth': {
      id: '/_auth';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AuthImport;
      parentRoute: typeof rootRoute;
    };
    '/app-select': {
      id: '/app-select';
      path: '/app-select';
      fullPath: '/app-select';
      preLoaderRoute: typeof AppSelectImport;
      parentRoute: typeof rootRoute;
    };
    '/health-center-link': {
      id: '/health-center-link';
      path: '/health-center-link';
      fullPath: '/health-center-link';
      preLoaderRoute: typeof HealthCenterLinkImport;
      parentRoute: typeof rootRoute;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginImport;
      parentRoute: typeof rootRoute;
    };
    '/porter-login': {
      id: '/porter-login';
      path: '/porter-login';
      fullPath: '/porter-login';
      preLoaderRoute: typeof PorterLoginImport;
      parentRoute: typeof rootRoute;
    };
    '/qr-code-scan': {
      id: '/qr-code-scan';
      path: '/qr-code-scan';
      fullPath: '/qr-code-scan';
      preLoaderRoute: typeof QrCodeScanImport;
      parentRoute: typeof rootRoute;
    };
    '/_auth/environmental-cleaning': {
      id: '/_auth/environmental-cleaning';
      path: '/environmental-cleaning';
      fullPath: '/environmental-cleaning';
      preLoaderRoute: typeof AuthEnvironmentalCleaningRouteImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/patient-transport/fares': {
      id: '/_auth/patient-transport/fares';
      path: '/patient-transport/fares';
      fullPath: '/patient-transport/fares';
      preLoaderRoute: typeof AuthPatientTransportFaresRouteImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/bed-management/archives': {
      id: '/_auth/bed-management/archives';
      path: '/bed-management/archives';
      fullPath: '/bed-management/archives';
      preLoaderRoute: typeof AuthBedManagementArchivesImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/bed-management/requests': {
      id: '/_auth/bed-management/requests';
      path: '/bed-management/requests';
      fullPath: '/bed-management/requests';
      preLoaderRoute: typeof AuthBedManagementRequestsImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/bed-management/statistics': {
      id: '/_auth/bed-management/statistics';
      path: '/bed-management/statistics';
      fullPath: '/bed-management/statistics';
      preLoaderRoute: typeof AuthBedManagementStatisticsImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/environmental-cleaning/done': {
      id: '/_auth/environmental-cleaning/done';
      path: '/done';
      fullPath: '/environmental-cleaning/done';
      preLoaderRoute: typeof AuthEnvironmentalCleaningDoneImport;
      parentRoute: typeof AuthEnvironmentalCleaningRouteImport;
    };
    '/_auth/environmental-cleaning/missions': {
      id: '/_auth/environmental-cleaning/missions';
      path: '/missions';
      fullPath: '/environmental-cleaning/missions';
      preLoaderRoute: typeof AuthEnvironmentalCleaningMissionsImport;
      parentRoute: typeof AuthEnvironmentalCleaningRouteImport;
    };
    '/_auth/bed-management/': {
      id: '/_auth/bed-management/';
      path: '/bed-management';
      fullPath: '/bed-management';
      preLoaderRoute: typeof AuthBedManagementIndexImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/environmental-cleaning/': {
      id: '/_auth/environmental-cleaning/';
      path: '/';
      fullPath: '/environmental-cleaning/';
      preLoaderRoute: typeof AuthEnvironmentalCleaningIndexImport;
      parentRoute: typeof AuthEnvironmentalCleaningRouteImport;
    };
    '/_auth/patient-transport/': {
      id: '/_auth/patient-transport/';
      path: '/patient-transport';
      fullPath: '/patient-transport';
      preLoaderRoute: typeof AuthPatientTransportIndexImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/bed-management/archives/$id': {
      id: '/_auth/bed-management/archives/$id';
      path: '/$id';
      fullPath: '/bed-management/archives/$id';
      preLoaderRoute: typeof AuthBedManagementArchivesIdImport;
      parentRoute: typeof AuthBedManagementArchivesImport;
    };
    '/_auth/bed-management/requests/$id': {
      id: '/_auth/bed-management/requests/$id';
      path: '/$id';
      fullPath: '/bed-management/requests/$id';
      preLoaderRoute: typeof AuthBedManagementRequestsIdImport;
      parentRoute: typeof AuthBedManagementRequestsImport;
    };
    '/_auth/environmental-cleaning/missions/$id': {
      id: '/_auth/environmental-cleaning/missions/$id';
      path: '/$id';
      fullPath: '/environmental-cleaning/missions/$id';
      preLoaderRoute: typeof AuthEnvironmentalCleaningMissionsIdImport;
      parentRoute: typeof AuthEnvironmentalCleaningMissionsImport;
    };
    '/_auth/patient-transport/fares/active': {
      id: '/_auth/patient-transport/fares/active';
      path: '/active';
      fullPath: '/patient-transport/fares/active';
      preLoaderRoute: typeof AuthPatientTransportFaresActiveImport;
      parentRoute: typeof AuthPatientTransportFaresRouteImport;
    };
    '/_auth/patient-transport/fares/done': {
      id: '/_auth/patient-transport/fares/done';
      path: '/done';
      fullPath: '/patient-transport/fares/done';
      preLoaderRoute: typeof AuthPatientTransportFaresDoneImport;
      parentRoute: typeof AuthPatientTransportFaresRouteImport;
    };
    '/_auth/patient-transport/fares/': {
      id: '/_auth/patient-transport/fares/';
      path: '/';
      fullPath: '/patient-transport/fares/';
      preLoaderRoute: typeof AuthPatientTransportFaresIndexImport;
      parentRoute: typeof AuthPatientTransportFaresRouteImport;
    };
    '/_auth/patient-transport/fares/active/$id/report-incident': {
      id: '/_auth/patient-transport/fares/active/$id/report-incident';
      path: '/$id/report-incident';
      fullPath: '/patient-transport/fares/active/$id/report-incident';
      preLoaderRoute: typeof AuthPatientTransportFaresActiveIdReportIncidentImport;
      parentRoute: typeof AuthPatientTransportFaresActiveImport;
    };
  }
}

// Create and export the route tree

interface AuthEnvironmentalCleaningMissionsRouteChildren {
  AuthEnvironmentalCleaningMissionsIdRoute: typeof AuthEnvironmentalCleaningMissionsIdRoute;
}

const AuthEnvironmentalCleaningMissionsRouteChildren: AuthEnvironmentalCleaningMissionsRouteChildren = {
  AuthEnvironmentalCleaningMissionsIdRoute: AuthEnvironmentalCleaningMissionsIdRoute,
};

const AuthEnvironmentalCleaningMissionsRouteWithChildren = AuthEnvironmentalCleaningMissionsRoute._addFileChildren(
  AuthEnvironmentalCleaningMissionsRouteChildren
);

interface AuthEnvironmentalCleaningRouteRouteChildren {
  AuthEnvironmentalCleaningDoneRoute: typeof AuthEnvironmentalCleaningDoneRoute;
  AuthEnvironmentalCleaningMissionsRoute: typeof AuthEnvironmentalCleaningMissionsRouteWithChildren;
  AuthEnvironmentalCleaningIndexRoute: typeof AuthEnvironmentalCleaningIndexRoute;
}

const AuthEnvironmentalCleaningRouteRouteChildren: AuthEnvironmentalCleaningRouteRouteChildren = {
  AuthEnvironmentalCleaningDoneRoute: AuthEnvironmentalCleaningDoneRoute,
  AuthEnvironmentalCleaningMissionsRoute: AuthEnvironmentalCleaningMissionsRouteWithChildren,
  AuthEnvironmentalCleaningIndexRoute: AuthEnvironmentalCleaningIndexRoute,
};

const AuthEnvironmentalCleaningRouteRouteWithChildren = AuthEnvironmentalCleaningRouteRoute._addFileChildren(
  AuthEnvironmentalCleaningRouteRouteChildren
);

interface AuthPatientTransportFaresActiveRouteChildren {
  AuthPatientTransportFaresActiveIdReportIncidentRoute: typeof AuthPatientTransportFaresActiveIdReportIncidentRoute;
}

const AuthPatientTransportFaresActiveRouteChildren: AuthPatientTransportFaresActiveRouteChildren = {
  AuthPatientTransportFaresActiveIdReportIncidentRoute: AuthPatientTransportFaresActiveIdReportIncidentRoute,
};

const AuthPatientTransportFaresActiveRouteWithChildren = AuthPatientTransportFaresActiveRoute._addFileChildren(
  AuthPatientTransportFaresActiveRouteChildren
);

interface AuthPatientTransportFaresRouteRouteChildren {
  AuthPatientTransportFaresActiveRoute: typeof AuthPatientTransportFaresActiveRouteWithChildren;
  AuthPatientTransportFaresDoneRoute: typeof AuthPatientTransportFaresDoneRoute;
  AuthPatientTransportFaresIndexRoute: typeof AuthPatientTransportFaresIndexRoute;
}

const AuthPatientTransportFaresRouteRouteChildren: AuthPatientTransportFaresRouteRouteChildren = {
  AuthPatientTransportFaresActiveRoute: AuthPatientTransportFaresActiveRouteWithChildren,
  AuthPatientTransportFaresDoneRoute: AuthPatientTransportFaresDoneRoute,
  AuthPatientTransportFaresIndexRoute: AuthPatientTransportFaresIndexRoute,
};

const AuthPatientTransportFaresRouteRouteWithChildren = AuthPatientTransportFaresRouteRoute._addFileChildren(
  AuthPatientTransportFaresRouteRouteChildren
);

interface AuthBedManagementArchivesRouteChildren {
  AuthBedManagementArchivesIdRoute: typeof AuthBedManagementArchivesIdRoute;
}

const AuthBedManagementArchivesRouteChildren: AuthBedManagementArchivesRouteChildren = {
  AuthBedManagementArchivesIdRoute: AuthBedManagementArchivesIdRoute,
};

const AuthBedManagementArchivesRouteWithChildren = AuthBedManagementArchivesRoute._addFileChildren(
  AuthBedManagementArchivesRouteChildren
);

interface AuthBedManagementRequestsRouteChildren {
  AuthBedManagementRequestsIdRoute: typeof AuthBedManagementRequestsIdRoute;
}

const AuthBedManagementRequestsRouteChildren: AuthBedManagementRequestsRouteChildren = {
  AuthBedManagementRequestsIdRoute: AuthBedManagementRequestsIdRoute,
};

const AuthBedManagementRequestsRouteWithChildren = AuthBedManagementRequestsRoute._addFileChildren(
  AuthBedManagementRequestsRouteChildren
);

interface AuthRouteChildren {
  AuthEnvironmentalCleaningRouteRoute: typeof AuthEnvironmentalCleaningRouteRouteWithChildren;
  AuthPatientTransportFaresRouteRoute: typeof AuthPatientTransportFaresRouteRouteWithChildren;
  AuthBedManagementArchivesRoute: typeof AuthBedManagementArchivesRouteWithChildren;
  AuthBedManagementRequestsRoute: typeof AuthBedManagementRequestsRouteWithChildren;
  AuthBedManagementStatisticsRoute: typeof AuthBedManagementStatisticsRoute;
  AuthBedManagementIndexRoute: typeof AuthBedManagementIndexRoute;
  AuthPatientTransportIndexRoute: typeof AuthPatientTransportIndexRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthEnvironmentalCleaningRouteRoute: AuthEnvironmentalCleaningRouteRouteWithChildren,
  AuthPatientTransportFaresRouteRoute: AuthPatientTransportFaresRouteRouteWithChildren,
  AuthBedManagementArchivesRoute: AuthBedManagementArchivesRouteWithChildren,
  AuthBedManagementRequestsRoute: AuthBedManagementRequestsRouteWithChildren,
  AuthBedManagementStatisticsRoute: AuthBedManagementStatisticsRoute,
  AuthBedManagementIndexRoute: AuthBedManagementIndexRoute,
  AuthPatientTransportIndexRoute: AuthPatientTransportIndexRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '': typeof AuthRouteWithChildren;
  '/app-select': typeof AppSelectRoute;
  '/health-center-link': typeof HealthCenterLinkRoute;
  '/login': typeof LoginRoute;
  '/porter-login': typeof PorterLoginRoute;
  '/qr-code-scan': typeof QrCodeScanRoute;
  '/environmental-cleaning': typeof AuthEnvironmentalCleaningRouteRouteWithChildren;
  '/patient-transport/fares': typeof AuthPatientTransportFaresRouteRouteWithChildren;
  '/bed-management/archives': typeof AuthBedManagementArchivesRouteWithChildren;
  '/bed-management/requests': typeof AuthBedManagementRequestsRouteWithChildren;
  '/bed-management/statistics': typeof AuthBedManagementStatisticsRoute;
  '/environmental-cleaning/done': typeof AuthEnvironmentalCleaningDoneRoute;
  '/environmental-cleaning/missions': typeof AuthEnvironmentalCleaningMissionsRouteWithChildren;
  '/bed-management': typeof AuthBedManagementIndexRoute;
  '/environmental-cleaning/': typeof AuthEnvironmentalCleaningIndexRoute;
  '/patient-transport': typeof AuthPatientTransportIndexRoute;
  '/bed-management/archives/$id': typeof AuthBedManagementArchivesIdRoute;
  '/bed-management/requests/$id': typeof AuthBedManagementRequestsIdRoute;
  '/environmental-cleaning/missions/$id': typeof AuthEnvironmentalCleaningMissionsIdRoute;
  '/patient-transport/fares/active': typeof AuthPatientTransportFaresActiveRouteWithChildren;
  '/patient-transport/fares/done': typeof AuthPatientTransportFaresDoneRoute;
  '/patient-transport/fares/': typeof AuthPatientTransportFaresIndexRoute;
  '/patient-transport/fares/active/$id/report-incident': typeof AuthPatientTransportFaresActiveIdReportIncidentRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '': typeof AuthRouteWithChildren;
  '/app-select': typeof AppSelectRoute;
  '/health-center-link': typeof HealthCenterLinkRoute;
  '/login': typeof LoginRoute;
  '/porter-login': typeof PorterLoginRoute;
  '/qr-code-scan': typeof QrCodeScanRoute;
  '/bed-management/archives': typeof AuthBedManagementArchivesRouteWithChildren;
  '/bed-management/requests': typeof AuthBedManagementRequestsRouteWithChildren;
  '/bed-management/statistics': typeof AuthBedManagementStatisticsRoute;
  '/environmental-cleaning/done': typeof AuthEnvironmentalCleaningDoneRoute;
  '/environmental-cleaning/missions': typeof AuthEnvironmentalCleaningMissionsRouteWithChildren;
  '/bed-management': typeof AuthBedManagementIndexRoute;
  '/environmental-cleaning': typeof AuthEnvironmentalCleaningIndexRoute;
  '/patient-transport': typeof AuthPatientTransportIndexRoute;
  '/bed-management/archives/$id': typeof AuthBedManagementArchivesIdRoute;
  '/bed-management/requests/$id': typeof AuthBedManagementRequestsIdRoute;
  '/environmental-cleaning/missions/$id': typeof AuthEnvironmentalCleaningMissionsIdRoute;
  '/patient-transport/fares/active': typeof AuthPatientTransportFaresActiveRouteWithChildren;
  '/patient-transport/fares/done': typeof AuthPatientTransportFaresDoneRoute;
  '/patient-transport/fares': typeof AuthPatientTransportFaresIndexRoute;
  '/patient-transport/fares/active/$id/report-incident': typeof AuthPatientTransportFaresActiveIdReportIncidentRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/_auth': typeof AuthRouteWithChildren;
  '/app-select': typeof AppSelectRoute;
  '/health-center-link': typeof HealthCenterLinkRoute;
  '/login': typeof LoginRoute;
  '/porter-login': typeof PorterLoginRoute;
  '/qr-code-scan': typeof QrCodeScanRoute;
  '/_auth/environmental-cleaning': typeof AuthEnvironmentalCleaningRouteRouteWithChildren;
  '/_auth/patient-transport/fares': typeof AuthPatientTransportFaresRouteRouteWithChildren;
  '/_auth/bed-management/archives': typeof AuthBedManagementArchivesRouteWithChildren;
  '/_auth/bed-management/requests': typeof AuthBedManagementRequestsRouteWithChildren;
  '/_auth/bed-management/statistics': typeof AuthBedManagementStatisticsRoute;
  '/_auth/environmental-cleaning/done': typeof AuthEnvironmentalCleaningDoneRoute;
  '/_auth/environmental-cleaning/missions': typeof AuthEnvironmentalCleaningMissionsRouteWithChildren;
  '/_auth/bed-management/': typeof AuthBedManagementIndexRoute;
  '/_auth/environmental-cleaning/': typeof AuthEnvironmentalCleaningIndexRoute;
  '/_auth/patient-transport/': typeof AuthPatientTransportIndexRoute;
  '/_auth/bed-management/archives/$id': typeof AuthBedManagementArchivesIdRoute;
  '/_auth/bed-management/requests/$id': typeof AuthBedManagementRequestsIdRoute;
  '/_auth/environmental-cleaning/missions/$id': typeof AuthEnvironmentalCleaningMissionsIdRoute;
  '/_auth/patient-transport/fares/active': typeof AuthPatientTransportFaresActiveRouteWithChildren;
  '/_auth/patient-transport/fares/done': typeof AuthPatientTransportFaresDoneRoute;
  '/_auth/patient-transport/fares/': typeof AuthPatientTransportFaresIndexRoute;
  '/_auth/patient-transport/fares/active/$id/report-incident': typeof AuthPatientTransportFaresActiveIdReportIncidentRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | ''
    | '/app-select'
    | '/health-center-link'
    | '/login'
    | '/porter-login'
    | '/qr-code-scan'
    | '/environmental-cleaning'
    | '/patient-transport/fares'
    | '/bed-management/archives'
    | '/bed-management/requests'
    | '/bed-management/statistics'
    | '/environmental-cleaning/done'
    | '/environmental-cleaning/missions'
    | '/bed-management'
    | '/environmental-cleaning/'
    | '/patient-transport'
    | '/bed-management/archives/$id'
    | '/bed-management/requests/$id'
    | '/environmental-cleaning/missions/$id'
    | '/patient-transport/fares/active'
    | '/patient-transport/fares/done'
    | '/patient-transport/fares/'
    | '/patient-transport/fares/active/$id/report-incident';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | ''
    | '/app-select'
    | '/health-center-link'
    | '/login'
    | '/porter-login'
    | '/qr-code-scan'
    | '/bed-management/archives'
    | '/bed-management/requests'
    | '/bed-management/statistics'
    | '/environmental-cleaning/done'
    | '/environmental-cleaning/missions'
    | '/bed-management'
    | '/environmental-cleaning'
    | '/patient-transport'
    | '/bed-management/archives/$id'
    | '/bed-management/requests/$id'
    | '/environmental-cleaning/missions/$id'
    | '/patient-transport/fares/active'
    | '/patient-transport/fares/done'
    | '/patient-transport/fares'
    | '/patient-transport/fares/active/$id/report-incident';
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/app-select'
    | '/health-center-link'
    | '/login'
    | '/porter-login'
    | '/qr-code-scan'
    | '/_auth/environmental-cleaning'
    | '/_auth/patient-transport/fares'
    | '/_auth/bed-management/archives'
    | '/_auth/bed-management/requests'
    | '/_auth/bed-management/statistics'
    | '/_auth/environmental-cleaning/done'
    | '/_auth/environmental-cleaning/missions'
    | '/_auth/bed-management/'
    | '/_auth/environmental-cleaning/'
    | '/_auth/patient-transport/'
    | '/_auth/bed-management/archives/$id'
    | '/_auth/bed-management/requests/$id'
    | '/_auth/environmental-cleaning/missions/$id'
    | '/_auth/patient-transport/fares/active'
    | '/_auth/patient-transport/fares/done'
    | '/_auth/patient-transport/fares/'
    | '/_auth/patient-transport/fares/active/$id/report-incident';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthRoute: typeof AuthRouteWithChildren;
  AppSelectRoute: typeof AppSelectRoute;
  HealthCenterLinkRoute: typeof HealthCenterLinkRoute;
  LoginRoute: typeof LoginRoute;
  PorterLoginRoute: typeof PorterLoginRoute;
  QrCodeScanRoute: typeof QrCodeScanRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AppSelectRoute: AppSelectRoute,
  HealthCenterLinkRoute: HealthCenterLinkRoute,
  LoginRoute: LoginRoute,
  PorterLoginRoute: PorterLoginRoute,
  QrCodeScanRoute: QrCodeScanRoute,
};

export const routeTree = rootRoute._addFileChildren(rootRouteChildren)._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/app-select",
        "/health-center-link",
        "/login",
        "/porter-login",
        "/qr-code-scan"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/environmental-cleaning",
        "/_auth/patient-transport/fares",
        "/_auth/bed-management/archives",
        "/_auth/bed-management/requests",
        "/_auth/bed-management/statistics",
        "/_auth/bed-management/",
        "/_auth/patient-transport/"
      ]
    },
    "/app-select": {
      "filePath": "app-select.tsx"
    },
    "/health-center-link": {
      "filePath": "health-center-link.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/porter-login": {
      "filePath": "porter-login.tsx"
    },
    "/qr-code-scan": {
      "filePath": "qr-code-scan.tsx"
    },
    "/_auth/environmental-cleaning": {
      "filePath": "_auth/environmental-cleaning.route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/environmental-cleaning/done",
        "/_auth/environmental-cleaning/missions",
        "/_auth/environmental-cleaning/"
      ]
    },
    "/_auth/patient-transport/fares": {
      "filePath": "_auth/patient-transport/fares.route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/patient-transport/fares/active",
        "/_auth/patient-transport/fares/done",
        "/_auth/patient-transport/fares/"
      ]
    },
    "/_auth/bed-management/archives": {
      "filePath": "_auth/bed-management/archives.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/bed-management/archives/$id"
      ]
    },
    "/_auth/bed-management/requests": {
      "filePath": "_auth/bed-management/requests.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/bed-management/requests/$id"
      ]
    },
    "/_auth/bed-management/statistics": {
      "filePath": "_auth/bed-management/statistics.tsx",
      "parent": "/_auth"
    },
    "/_auth/environmental-cleaning/done": {
      "filePath": "_auth/environmental-cleaning.done.tsx",
      "parent": "/_auth/environmental-cleaning"
    },
    "/_auth/environmental-cleaning/missions": {
      "filePath": "_auth/environmental-cleaning.missions.tsx",
      "parent": "/_auth/environmental-cleaning",
      "children": [
        "/_auth/environmental-cleaning/missions/$id"
      ]
    },
    "/_auth/bed-management/": {
      "filePath": "_auth/bed-management/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/environmental-cleaning/": {
      "filePath": "_auth/environmental-cleaning.index.tsx",
      "parent": "/_auth/environmental-cleaning"
    },
    "/_auth/patient-transport/": {
      "filePath": "_auth/patient-transport/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/bed-management/archives/$id": {
      "filePath": "_auth/bed-management/archives.$id.tsx",
      "parent": "/_auth/bed-management/archives"
    },
    "/_auth/bed-management/requests/$id": {
      "filePath": "_auth/bed-management/requests.$id.tsx",
      "parent": "/_auth/bed-management/requests"
    },
    "/_auth/environmental-cleaning/missions/$id": {
      "filePath": "_auth/environmental-cleaning.missions.$id.tsx",
      "parent": "/_auth/environmental-cleaning/missions"
    },
    "/_auth/patient-transport/fares/active": {
      "filePath": "_auth/patient-transport/fares.active.tsx",
      "parent": "/_auth/patient-transport/fares",
      "children": [
        "/_auth/patient-transport/fares/active/$id/report-incident"
      ]
    },
    "/_auth/patient-transport/fares/done": {
      "filePath": "_auth/patient-transport/fares.done.tsx",
      "parent": "/_auth/patient-transport/fares"
    },
    "/_auth/patient-transport/fares/": {
      "filePath": "_auth/patient-transport/fares.index.tsx",
      "parent": "/_auth/patient-transport/fares"
    },
    "/_auth/patient-transport/fares/active/$id/report-incident": {
      "filePath": "_auth/patient-transport/fares.active.$id.report-incident.tsx",
      "parent": "/_auth/patient-transport/fares/active"
    }
  }
}
ROUTE_MANIFEST_END */
